import { createSlice } from "@reduxjs/toolkit";

// Define initial state for access rights
const initialState = [];

// Create a slice for access rights
const accessRightsSlice = createSlice({
  name: "accessRights",
  initialState,
  reducers: {
    // Action to set access rights
    setAccessRights: (state, action) => {
      console.log("Access payload received:", action.payload);
      return action.payload;
    },
    // Action to clear access rights
    clearAccessRights: () => {
      return [];
    },
  },
});

// Export actions for use in components
export const { setAccessRights, clearAccessRights } = accessRightsSlice.actions;

// Export reducer to be included in the store
export default accessRightsSlice.reducer;
